import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { SharedModule } from '../shared/shared.module';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { ShortestPathComponent } from './shortest-path/shortest-path.component';
import { TShortestPathComponent } from './t-shortest-path/t-shortest-path.component';
import { VertexCoverComponent } from './vertex-cover/vertex-cover.component';
import { TVertexCoverComponent } from './t-vertex-cover/t-vertex-cover.component';
import { MinimumSpanningTreeComponent } from './minimum-spanning-tree/minimum-spanning-tree.component';
import { TMinimumSpanningTreeComponent } from './t-minimum-spanning-tree/t-minimum-spanning-tree.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    NgbModule,
    SharedModule
  ],providers: [TopicService,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    TExercisesComponent, 
    TAllExercisesComponent, 
    ExamComponent, 
    EvaluationComponent, 
    OpenQuestionComponent, 
    TOpenQuestionComponent, 
    TExamComponent, 
    TAllExamsComponent, 
    MultipleChoiceComponent, 
    TMultipleChoiceComponent, ShortestPathComponent, TShortestPathComponent, VertexCoverComponent, TVertexCoverComponent, MinimumSpanningTreeComponent, TMinimumSpanningTreeComponent
  ]
})
export class OptimalSolutionsModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}

